import Table from '@/src/components/Antd/Table/SizeFittingTable';
import { getSalesChannelTimezoneGmt } from '@/src/constrains/SalesChannelHOC/slice';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import Status from '@/src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/StatusTag';
import { get } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { isNumber } from 'src/tools/helper';
import { i18nGet, handleOnFormatCurrentSCTimeAndDate } from 'src/tools/tools';
import { EnumTablePosition } from 'src/types/common/common';
import css from './table.module.less';
import { useSalesChannel } from 'src/constrains/SalesChannelHOC/useSalesChannel';

const FlashTable = (props) => {
  const timezoneGmt = useSelector(getSalesChannelTimezoneGmt());
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data } = props;
  const sc = useSalesChannel();
  const decimalPosition = get(sc, 'decimalPosition');
  console.log('decimalPosition', decimalPosition);
  const { saleChannelUuid }: any = useParams();
  //
  const h = useHistory();
  const { alias, salesChannelProduct, products, currency } = data || {};
  const { name, uuid } = salesChannelProduct || {};
  const col = [
    {
      minWidth: 220,
      title: getI18n('general.storeCommunicationSetting.product'),
      key: 'Product',
      default: true,
      className: css.firstCol,
      propsGenerate: (a, record, index) => {
        const rowSpan = get(record, 'rowSpan');
        return { rowSpan };
      },
      childGenerate: (a, record, index) => {
        const productName = get(record, 'productName');
        const sku = get(record, 'sku');
        const title = `${sku || ''} ${productName || ''}`;
        return (
          <NoWrapContainer>
            <Tooltip title={title}>{title}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 160,
      title: getI18n('general.flashSaleTitle'),
      key: 'title',
      default: true,
      childGenerate: (a, record, index) => {
        const name = get(record, 'name');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      titleGenerate: () => getI18n('general.status'),
      position: EnumTablePosition.mid,
      key: 'Status',
      default: true,
      childGenerate: (url, record, index) => {
        const status = get(record, 'status');
        return <Status status={status} />;
      },
      width: 112,
    },
    {
      titleGenerate: () =>
        `${getI18n('general.startTime')} (UTC ${timezoneGmt})`,
      position: EnumTablePosition.mid,
      key: 'start',
      default: true,
      childGenerate: (url, record, index) => {
        const activeStartTime = get(record, 'activeStartTime');
        const time = activeStartTime
          ? handleOnFormatCurrentSCTimeAndDate(activeStartTime)
          : '-';
        return (
          <NoWrapContainer>
            <Tooltip title={time}>{time}</Tooltip>
          </NoWrapContainer>
        );
      },
      width: 144,
    },
    {
      titleGenerate: () => `${getI18n('general.endTime')} (UTC ${timezoneGmt})`,
      position: EnumTablePosition.mid,
      key: 'end',
      default: true,
      childGenerate: (url, record, index) => {
        const activeEndTime = get(record, 'activeEndTime');
        const time = activeEndTime
          ? handleOnFormatCurrentSCTimeAndDate(activeEndTime)
          : '-';

        return (
          <NoWrapContainer>
            <Tooltip title={time}>{time}</Tooltip>
          </NoWrapContainer>
        );
      },
      width: 144,
    },
    {
      titleGenerate: () =>
        `${getI18n(
          'salesChannelProductDetail.index.flashSalePrice',
        )} (${currency})`,
      position: EnumTablePosition.right,
      key: 'price',
      default: true,
      childGenerate: (url, record, index) => {
        const _price = get(record, 'price');
        const price =
          isNumber(_price) && isNumber(decimalPosition)
            ? _price.toFixed(decimalPosition)
            : '-';
        return (
          <NoWrapContainer>
            <Tooltip title={price}>{price}</Tooltip>
          </NoWrapContainer>
        );
      },
      width: 160,
    },
    {
      titleGenerate: () =>
        getI18n('general.advancedFilters.commonStoreProductsWithTable.actions'),
      position: EnumTablePosition.mid,
      key: 'Action',
      default: true,
      childGenerate: (url, record, index) => {
        // console.log(record);
        const { uuid } = record;
        // const _price = get(record, 'price');
        // const price = isNumber(_price) ? _price.toFixed(2) : '-';
        return (
          <Actions
            onEdit={() => {
              h.push(
                `/salesChannel/discounts/flashSale/editor/${saleChannelUuid}/${uuid}`,
              );
              //   _list.splice(index, 1);
              //   onOk(_list);
              //  remove(index);
            }}
          />
        );
      },
      width: 120,
    },
  ];
  return (
    <Section className={css.container}>
      <div className={css.title}>
        {alias ? getI18n('general.sider.alias') : ''} {name || ''}
      </div>
      <Table
        rowKey={(record) => {
          // console.log('record', record);
          const { uuid, productUuid } = record;
          return `${uuid}-${productUuid}`;
        }}
        pagination={false}
        dataSource={products || []}
        id={`${uuid}SalesChannelFlashSaleTable`}
        columns={col}
      />
    </Section>
  );
};
export default FlashTable;
